/* carousel-drag.js — kéo bằng chuột cho các băng cuộn ngang. Một bản dùng chung.
 *
 * VÌ SAO GỘP LẠI
 * Trước đây mỗi section tự viết một bản kéo riêng: strap-tabs, collection-cards,
 * review-carousel, process-carousel, featured-blog — năm bản, năm kiểu. Đó là gốc
 * của cả chuỗi lỗi ngày 20/08: băng này tắt scroll-snap trong lúc kéo, băng kia
 * quên nên giật; băng này chặn `dragstart`, băng kia quên nên trình duyệt kéo cái
 * ảnh ra ngoài và nuốt luôn `pointermove`. Sửa một băng không làm băng khác đỡ.
 *
 * PHẠM VI
 * Chỉ dùng cho băng CUỘN TỰ DO (danh sách chạy ngang): review, tab sản phẩm,
 * collection. KHÔNG dùng cho hai băng TIÊU ĐIỂM (18 bước, blog) — hai băng đó
 * thả tay là nhảy hẳn sang thẻ kế tiếp, một kiểu tương tác khác hẳn, và chúng đã
 * có sẵn logic riêng đang chạy đúng.
 *
 * BA BÀI HỌC ĐÃ TRẢ GIÁ, GIỮ NGUYÊN Ở ĐÂY
 *  1. KHÔNG `setPointerCapture()` — nó nuốt cú bấm (ghi trong review-carousel.js).
 *  2. KHÔNG `pointer-events: none` lúc kéo — cũng nuốt cú bấm. Phân biệt kéo/bấm
 *     bằng CỜ rồi chặn `click` ở pha capture.
 *  3. PHẢI chặn `dragstart`, nếu không trình duyệt tưởng đang kéo ảnh/link ra
 *     ngoài, nuốt `pointermove` và băng đứng im.
 *
 * Cảm ứng thì KHÔNG đụng tới: bộ cuộn của hệ điều hành mượt hơn mọi thư viện JS,
 * chạy ngoài luồng chính và không tốn pin. Chỗ thiếu thật sự chỉ là chuột.
 */
(function () {
  'use strict';

  var MA_SAT = 0.93;      /* 0.90 dừng nhanh · 0.96 trượt xa */
  var TOC_TOI_THIEU = 0.35; /* px/khung, dưới ngưỡng này thì dừng và trả snap về */
  var NGUONG_KEO = 4;     /* px — dưới mức này coi là bấm, không phải kéo */

  var CAC_BANG = [
    '.srevc__rail',   /* From our customers */
    '.stabs__rail',   /* Handmade Watch Straps */
    '.ccards__rail',  /* Shop by Collections */
    '[data-carousel-drag]'
  ].join(',');

  function gan(rail) {
    if (!rail || rail.dataset.dragReady) return;
    rail.dataset.dragReady = '1';

    var snapGoc = getComputedStyle(rail).scrollSnapType;
    var xuong = false, daKeo = false;
    var xDau = 0, cuonDau = 0, xTruoc = 0, tTruoc = 0, toc = 0, raf = 0;

    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;   /* cảm ứng: để hệ điều hành lo */
      xuong = true; daKeo = false;
      xDau = e.clientX; cuonDau = rail.scrollLeft;
      xTruoc = e.clientX; tTruoc = (performance && performance.now) ? performance.now() : Date.now();
      toc = 0;
      cancelAnimationFrame(raf);
      rail.style.scrollBehavior = 'auto';
      rail.classList.add('is-dragging');
    });

    rail.addEventListener('pointermove', function (e) {
      if (!xuong) return;
      var dx = e.clientX - xDau;
      if (Math.abs(dx) > NGUONG_KEO) {
        daKeo = true;
        /* Tắt snap NGAY khi thành cú kéo thật, không tắt sẵn từ pointerdown:
           tắt sẵn thì một cú bấm hụt cũng làm băng trôi khỏi điểm đậu. */
        rail.style.scrollSnapType = 'none';
        e.preventDefault();
      }
      rail.scrollLeft = cuonDau - dx;

      var t = (performance && performance.now) ? performance.now() : Date.now();
      var dt = t - tTruoc;
      if (dt > 0) {
        toc = (e.clientX - xTruoc) / dt * 16;   /* px mỗi khung ở 60fps */
        xTruoc = e.clientX; tTruoc = t;
      }
    });

    function traSnap() {
      rail.style.scrollSnapType = snapGoc || '';
      rail.style.scrollBehavior = '';
    }

    function tha() {
      if (!xuong) return;
      xuong = false;
      rail.classList.remove('is-dragging');
      if (!daKeo) { traSnap(); return; }

      var v = -toc;
      (function truot() {
        if (Math.abs(v) < TOC_TOI_THIEU) { traSnap(); return; }
        rail.scrollLeft += v;
        v *= MA_SAT;
        raf = requestAnimationFrame(truot);
      })();
    }

    rail.addEventListener('pointerup', tha);
    rail.addEventListener('pointercancel', tha);
    rail.addEventListener('pointerleave', tha);

    /* Kéo xong thì đừng mở sản phẩm. Chặn ở pha CAPTURE để tới trước mọi
       handler của thẻ, và chỉ chặn đúng một lần. */
    rail.addEventListener('click', function (e) {
      if (!daKeo) return;
      daKeo = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function khoiTao() {
    document.querySelectorAll(CAC_BANG).forEach(gan);
  }

  if (document.readyState !== 'loading') khoiTao();
  else document.addEventListener('DOMContentLoaded', khoiTao);

  /* Theme editor nạp lại section thì gắn cho băng mới */
  document.addEventListener('shopify:section:load', khoiTao);
})();
